// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import xCloseIcon from "@/assets/icons/x-close.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type XCloseIconProps = Omit<IconProps, "name">;

export function XCloseIcon(props: XCloseIconProps): React.ReactNode {
  return <Icon name={xCloseIcon} {...props} />;
}
